import type ReloaderService from '../../services/reloader.service';
import type {AjaxService} from 'core/data-services/ajax.service';

export default class LocaleDataService {
    static serviceName = 'localeDataService';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService, private reloader: ReloaderService) {
    }

    public async setLocale(language) {
        await this.ajaxService.withoutBaseUrl().createRequest('set/setLocale').get({language});
        this.reloader.reload();


    }
}